class BtnLoader {
  constructor(element) {
    this.btnLoader = element;

    this.events();
  }
  
  addLoader() {
    const loaderWrapper = document.createElement('div');
    loaderWrapper.classList.add('page-loader', 'd-f', 'ai-c', 'jc-c');

    const loaderElement = document.createElement('img');
    loaderElement.src = '/themes/siblu/dist/assets/img/loader-big.gif';
    loaderElement.alt = 'Loading...';

    loaderWrapper.prepend(loaderElement);
    this.btnLoader.before(loaderWrapper);

    document.getElementsByTagName('body')[0].classList.add('loading', 'o-h');
  }  

  removeLoader() {
    const loaderWrapper = document.querySelector('.page-loader');
    loaderWrapper.remove();
    document.getElementsByTagName('body')[0].classList.remove('loading', 'o-h');
  }

  events() {
    this.btnLoader.addEventListener('click', () => {
      this.addLoader();
    });
    
    window.onpageshow = (event) => {
      if (event.persisted && document.getElementsByTagName('body')[0].classList.contains('loading')) {
        this.removeLoader();
      }
    };
  }
}

const btnLoaders = document.querySelectorAll('[data-btn-loader]');
btnLoaders.forEach((btnLoader) => {
  btnLoader.btnLoader = new BtnLoader(btnLoader);
});